import ReactPlayer from 'react-player';
import DataAnimation from "../../../../src/assetsWeb/images/data.mp4";
import * as React from 'react';
export default {
  ReactPlayer,
  DataAnimation,
  React
};